(() => {
  if (customElements.get('fe-tt-video')) return;
  class TamponVideo extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const video = this.querySelector('video');
      if (!video) return;
      this.video = video;
      const start = this.querySelector('.fe-ttv-start'), toggle = this.querySelector('.fe-ttv-toggle'), progress = this.querySelector('.fe-ttv-progress'), time = this.querySelector('.fe-ttv-time'), end = this.querySelector('.fe-ttv-end');
      const format = value => Math.floor(value / 60) + ':' + String(Math.floor(value % 60)).padStart(2, '0');
      video.controls = false;
      this.querySelector('.fe-ttv-bar').hidden = false;
      start.hidden = false;
      const playPause = async () => {
        if (!video.paused) { video.pause(); return; }
        if (video.ended) video.currentTime = 0;
        try { await video.play(); } catch { video.controls = true; start.hidden = true; }
      };
      start.addEventListener('click', playPause, {signal});
      toggle.addEventListener('click', playPause, {signal});
      const sync = () => {
        const playing = !video.paused && !video.ended;
        start.hidden = playing;
        toggle.setAttribute('aria-label', playing ? this.dataset.pause : this.dataset.play);
        toggle.querySelector('span').textContent = playing ? this.dataset.pause : this.dataset.play;
        toggle.querySelector('path').setAttribute('d', playing ? 'M8 4v16M16 4v16' : 'm8 4 12 8-12 8V4Z');
        end.hidden = !video.ended;
      };
      for (const event of ['play', 'pause', 'ended']) video.addEventListener(event, sync, {signal});
      video.addEventListener('loadedmetadata', () => { progress.max = video.duration; }, {signal});
      video.addEventListener('timeupdate', () => {
        progress.value = video.currentTime;
        time.textContent = format(video.currentTime) + ' / ' + format(video.duration || 32.2);
        progress.setAttribute('aria-valuetext', format(video.currentTime) + ' ' + this.dataset.of + ' ' + format(video.duration || 32.2));
      }, {signal});
      progress.addEventListener('input', () => { if (video.readyState) video.currentTime = Number(progress.value); }, {signal});
      this.querySelector('.fe-ttv-full').addEventListener('click', async () => {
        video.controls = true;
        try { if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); else await video.requestFullscreen(); }
        catch { video.scrollIntoView({block:'center'}); }
      }, {signal});
      document.addEventListener('fullscreenchange', () => { if (!document.fullscreenElement) video.controls = false; }, {signal});
      video.addEventListener('webkitendfullscreen', () => { video.controls = false; }, {signal});
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); }, {signal});
      this.querySelector('.fe-ttv-steps').addEventListener('click', event => {
        const target = document.querySelector('#test .tt-compare-steps-title');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
        history.replaceState(null,'','#'+target.id);
      }, {signal});
    }
    disconnectedCallback() { this.video?.pause(); this.controller?.abort(); this.controller = null; }
  }
  customElements.define('fe-tt-video', TamponVideo);
})();
